module.exports = __webpack_public_path__ + "img/content5-4.def9b3f1.webp";